module.exports = __webpack_public_path__ + "static/media/lamoderna_lamoderna.a1d95a00.png";